window.logger = {
  types: ['debug', 'error', 'group', 'groupEnd', 'info', 'log', 'warn'],
  old: {},
  pub: {},
  init: () => {
    for (var type of window.logger.types) {
      window.logger.old[type] = window.console[type];
    }
  },
  enable: () => {
    for (var type of window.logger.types) {
      window.console[type] = window.logger.old[type];
    }

    return 'Logger enabled';
  },
  disable: () => {
    for (var type of window.logger.types) {
      window.console[type] = () => { };
    }

    return 'Logger disabled';
  }
};

window.logger.init();